import { Modal, Popover } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context";
import { ENTITIES } from "../../entities/entitiesConfig";
import { lng } from "../../library/language";
import { InfoCircleOutlined } from "@ant-design/icons";
import { AiFillCloseCircle } from "react-icons/ai";
import { openkit } from "../../library/database";
import CloseBtn from "../../components/Buttons/CloseBtn";
import "./OrderDetails.css";
import CarbonFootprintInquiry from "../../components/CarbonFootprintInquiry/CarbonFootprintInquiry";

const popoverContent = (p) => {
  if (p)
    return React.createElement(ENTITIES[p?.type].CardContent, {
      entity: p?.type,
      product: p,
      context: "payment",
    });
};

function OrderDetails({ confirmedProducts, closeOrderDetails }) {
  const info = useContext(AppContext);

  async function getCheckout() {
    let manifest = await openkit.custom.execute("POST", "get_checkout");

    EasypayCheckoutUI.setup(manifest) // eslint-disable-line
      .then(function (modal) {
        modal.onCancel(function () {
          // This is triggered on popup close, if the checkout is not complete
          // alert("The checkout was canceled!");
        });
        modal.onClose(function () {
          // This is triggered on popup close, if the checkout is complete
          // alert("The checkout was closed!");
        });
        modal.onComplete(function (data) {
          alert("The checkout was finished");
          console.log(data);
          // closeOrderDetails();
        });
      });
  }

  useEffect(() => {
    (async () => {
      let script = document.createElement("script");
      document.head.appendChild(script);
      script.onload = function () {
        getCheckout();
      };
      script.src =
        "https://api.test.easypay.pt/assets/checkout/js/sdk/1.2.1/checkout.js";
    })();
  }, []);

  return (
    <>
      <div
        style={{ border: "1px solid grey", padding: 20, position: "relative" }}
      >
        <CloseBtn closeFn={closeOrderDetails} />
        <div className="ahp-payment-table">
          <table>
            <thead>
              <tr>
                <th>{info.t("entity")}</th>
                <th>{info.t("product")}</th>
                <th>{info.t("price")}</th>
              </tr>
            </thead>
            <tbody>
              {confirmedProducts.map((p, index) => (
                <tr key={index}>
                  <td>{lng(p.store_name, info.language)}</td>
                  <td>
                    <Popover
                      title={p.gen_name}
                      content={popoverContent(p)}
                      trigger="click"
                    >
                      <a>{p.gen_name} </a>
                      <InfoCircleOutlined
                        style={{ color: "#1890ff", cursor: "pointer" }}
                      />
                    </Popover>
                  </td>
                  <td>{p.total_price} €</td>
                </tr>
              ))}
              <tr>
                <td style={{ fontWeight: 600 }}>Total</td>
                <td></td>
                <td style={{ fontWeight: 600 }}>
                  {confirmedProducts.reduce(
                    (a, c) => (c ? a + c.total_price : a),
                    0
                  )}
                  €
                </td>
              </tr>
            </tbody>
          </table>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div id="easypay-checkout"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderDetails;
